import React, { Component } from "react";
import Container from "./styled";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { BsCheckLg, BsXLg } from "react-icons/bs";

export default class AcordeonContrata extends Component {
  render() {
    return (
      <Container>
        {/* Accordion */}
        <Accordion allowZeroExpanded>
          {/* Item */}
          <AccordionItem>
            {/* Heading */}
            <AccordionItemHeading className="heading">
              {/* Button */}
              <AccordionItemButton className="button">
                <div className="logoPlan opacidad6">
                  <img alt="Logo Seguro" src={this.props.logo}></img>
                  <p>{this.props.plan}</p>
                </div>
                <section className="checksPlan opacidad6">
                  <div>
                    <span>
                      {this.props.resCivil == "si" ? (
                        <BsCheckLg />
                      ) : (
                        <BsXLg id="checkNo" />
                      )}
                    </span>
                    <p>Resp. Civil</p>
                  </div>
                  <div>
                    <span>
                      {this.props.roboTotal == "si" ? (
                        <BsCheckLg />
                      ) : (
                        <BsXLg id="checkNo" />
                      )}
                    </span>
                    <p>Robo Total</p>
                  </div>
                  <div>
                    <span>
                      {this.props.roboParcial == "si" ? (
                        <BsCheckLg />
                      ) : (
                        <BsXLg id="checkNo" />
                      )}
                    </span>
                    <p>Robo Parcial</p>
                  </div>
                  <div>
                    <span>
                      {this.props.desTotal == "si" ? (
                        <BsCheckLg />
                      ) : (
                        <BsXLg id="checkNo" />
                      )}
                    </span>
                    <p>Dest. Total</p>
                  </div>
                  <div>
                    <span>
                      {this.props.asistencia == "si" ? (
                        <BsCheckLg />
                      ) : (
                        <BsXLg id="checkNo" />
                      )}
                    </span>
                    <p>Asistencia</p>
                  </div>
                  <div>
                    <span>
                      {this.props.competencias == "si" ? (
                        <BsCheckLg />
                      ) : (
                        <BsXLg id="checkNo" />
                      )}
                    </span>
                    <p>Competencias</p>
                  </div>
                  </section>
                  <div className="priceData">
                    <div className="cuotasContainer">
                      {this.props.cuotas == "" ? null : (
                        <p id="cuotas">{this.props.cuotas}</p>
                      )}
                      {this.props.precioAnterior == "" ? null : (
                        <p id="precioAnterior">{this.props.precioAnterior}</p>
                      )}
                    </div>
                    {this.props.precio == "" ? null : (
                      <div className="ofertaContainer">
                        {this.props.oferta == "" ? null : (
                          <p>{this.props.oferta}</p>
                        )}
                        <p>{this.props.precio}</p>
                      </div>
                    )}
                    {this.props.contratando == "" ? null : (
                      <div className="contratandoContainer">
                        <p>{this.props.contratando}</p>
                      </div>
                    )}
                  </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel></AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </Container>
    );
  }
}
